import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EnvironmentSlice } from '../app-state';

export const selectEnvironmentSlice = createFeatureSelector<EnvironmentSlice>('environmentSlice');

export const selectJiraUiBaseUrl = createSelector(selectEnvironmentSlice, (environmentSlice) => {
  return environmentSlice.jiraUiBaseUrl;
});

export const selectJiraDataCenterUrl = createSelector(selectEnvironmentSlice, (environmentSlice) => {
  return environmentSlice.jiraDataCenterUrl;
});

export const selectDeliveryGuid = createSelector(selectEnvironmentSlice, (environmentSlice) => {
  return environmentSlice.deliveryGuid;
});

export const selectJiraFieldMappings = createSelector(selectEnvironmentSlice, (environmentSlice) => {
  return environmentSlice.jiraFieldMappings;
});

export const selectIsJiraCloud = createSelector(selectEnvironmentSlice, (environmentSlice) => {
  return environmentSlice.isJiraCloud;
});
